export const faqs = [
  {
    id: 'faq-1',
    question: 'MJHL 产品的售后服务政策是怎样的？',
    answer: 'MJHL 全系产品享受一年免费保修服务，核心产品可延长至三年保修。我们提供 7x24 小时在线客服支持，全国 50+ 城市设有授权服务中心，承诺 48 小时内上门服务。购买 MJHL 产品还可享受 30 天无理由退换货政策。',
  },
  {
    id: 'faq-2',
    question: '如何成为 MJHL 的合作伙伴？',
    answer: 'MJHL 欢迎各类合作伙伴加入。您可以通过官网"合作咨询"提交合作意向，我们的渠道经理将在 48 小时内与您联系。我们提供渠道代理、技术集成、联合研发等多种合作模式，并为合作伙伴提供技术培训、市场推广、优先供货等专属权益。',
  },
  {
    id: 'faq-3',
    question: 'MJHL 智能家居产品是否支持跨品牌联动？',
    answer: '是的。MJHL 智能中枢 Hub Pro 支持 200+ 品牌设备接入，兼容 Zigbee、Wi-Fi、蓝牙 Mesh 等多种通信协议。即使您家中已有其他品牌的智能设备，也可以无缝接入 MJHL 智能家居生态系统，实现统一管理和场景联动。',
  },
  {
    id: 'faq-4',
    question: 'MJHL 企业服务产品的数据安全如何保障？',
    answer: 'MJHL 企业级产品已通过 ISO 27001 信息安全认证和等保三级认证。我们采用端到端加密传输、分布式存储架构、多重权限管理、操作审计日志等多重安全机制，确保企业数据安全。所有数据存储于国内服务器，严格遵守数据安全法规。',
  },
  {
    id: 'faq-5',
    question: 'MJHL 健康产品的监测数据准确吗？',
    answer: 'MJHL 健康产品采用自研 BioSense 生物传感芯片，经过严格的临床级校准。以 VitalBand Pro 为例，其心率监测与医疗级心电图的一致性达到 98%，血氧监测与专业脉搏血氧仪的一致性达到 97%。我们不替代医疗器械，但提供日常健康管理中极具参考价值的精准数据。',
  },
  {
    id: 'faq-6',
    question: 'MJHL 教育产品是否支持定制化开发？',
    answer: '支持。MJHL 教育产品提供灵活的定制化方案，可根据学校的教学特色和管理需求进行功能定制。我们的技术团队会与学校深度沟通需求，提供从需求分析、方案设计到部署实施的全流程定制服务。',
  },
];